export default __webpack_public_path__ + "static/media/Ashish.0c680830.png";